// @flow
import type { GatsbyBrowser } from 'gatsby'

export const registerServiceWorker: $ElementType<
  GatsbyBrowser,
  'registerServiceWorker'
> = () => true
